<template>
  <div>
    <Head :title="__('exam.manage')"/>
    <h1 class="h1">{{ __('exam.manage') }}</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
        <!--        <label class="block text-gray-700">Role:</label>-->
        <!--        <select v-model="form.role" class="form-select mt-1 w-full">-->
        <!--          <option :value="null" />-->
        <!--          <option value="exam">{{ __('filter.kjp') }}</option>-->
        <!--          <option value="owner">{{ __('filter.pp') }}</option>-->
        <!--        </select>-->
        <label class="block mt-4 text-gray-700">{{ __('filter.only_published') }}</label>
        <select v-model="form.only_published" class="form-select mt-1 w-full">
          <option :value="null"/>
          <option value="1">{{ __('filter.published') }}</option>
          <option value="0">{{ __('filter.drafts') }}</option>
        </select>
      </search-filter>
      <Link class="btn-primary" href="/exams/create">
        <span>{{ __('exam.create') }}</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-4 pt-6 px-6">ID</th>
          <th class="pb-4 pt-6 px-6">Name</th>
          <th class="pb-4 pt-6 px-6">Status</th>
          <th class="pb-4 pt-6 px-6">Kategorie</th>
          <th class="pb-4 pt-6 px-6">Jahr/Halbjahr</th>
          <th class="pb-4 pt-6 px-6">Anzahl der Fragen</th>
          <th class="pb-4 pt-6 px-6">Aktionen</th>
        </tr>
        <tr v-for="exam in exams.data" :key="exam.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-primary-500" :href="`/exams/${exam.id}/edit`">
              #{{ exam.id }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center px-6 py-4 focus:text-primary-500" :href="`/exams/${exam.id}/edit`">
              <img v-if="exam.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="exam.photo"/>
              {{ exam.name }}
              <icon v-if="exam.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400"/>
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex justify-start px-6 py-4" :href="`/exams/${exam.id}/edit`" tabindex="-1">
              {{ __('exam.status.' + exam.status) }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex justify-start px-6 py-4" :href="`/exams/${exam.id}/edit`" tabindex="-1">
              {{ exam.category.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex justify-start px-6 py-4" :href="`/exams/${exam.id}/edit`" tabindex="-1">
              {{ exam.year }}/{{ exam.half }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex justify-end px-6 py-4" :href="`/exams/${exam.id}/edit`" tabindex="-1">
              {{ exam.questions_count }}
            </Link>
          </td>
          <td class="w-px min-w-[200px] border-t">
            <Link v-if="exam.status === 1" class="flex justify-end px-4" :href="`/exams/${exam.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400"/>
            </Link>
            <div v-if="exam.status === 2" class="mr-4">
              <Link class="btn btn-primary flex justify-start px-4" :href="`/exams/${exam.id}/pretest`">
                Prüfung testen
              </Link>
            </div>

          </td>
        </tr>
        <tr v-if="exams.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">No exams found.</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="exams.links"/>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    exams: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
        // role: this.filters.role,
        only_published: this.filters.only_published,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        console.log('do')
        this.$inertia.get('/admin/exam', pickBy(this.form), {preserveState: true})
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
